import React from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { BUSINESS_TYPE_LABELS } from "@/lib/constants";
import { Check, X, Clock } from "lucide-react";

function Row({ p, children }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 py-3" data-testid={`partner-request-${p.profile_code}`}>
      <div>
        <p className="font-heading font-semibold text-stone-900">{p.name}</p>
        <p className="font-mono text-xs text-stone-500">{p.profile_code} · {BUSINESS_TYPE_LABELS[p.business_type] || p.business_type}</p>
      </div>
      <div className="flex gap-2">{children}</div>
    </div>
  );
}

export function PartnerRequests({ incoming, outgoing, onChanged, canAct, canCancel = canAct }) {
  const act = async (fn, msg) => { try { await fn(); toast.success(msg); onChanged(); } catch (e) { toast.error(e.response?.data?.detail || "Failed"); } };
  if (!incoming.length && !outgoing.length) return null;
  return (
    <div className="grid gap-4 lg:grid-cols-2" data-testid="partner-requests">
      {incoming.length > 0 && (
        <div className="rounded-2xl border border-[#C85A32]/30 bg-[#FDF6F2] p-5" data-testid="incoming-requests">
          <p className="text-xs font-semibold uppercase tracking-wider text-[#C85A32]">Connect requests for you ({incoming.length})</p>
          <div className="divide-y divide-[#F0E1D8]">
            {incoming.map((p) => (
              <Row key={p.rel_id} p={p}>
                {canAct && <>
                  <Button size="sm" data-testid={`accept-request-${p.profile_code}`} className="bg-[#0D5C3A] hover:bg-[#084229]" onClick={() => act(() => api.post(`/partners/${p.rel_id}/accept`), "Connected")}><Check className="mr-1 h-4 w-4" /> Accept</Button>
                  <Button size="sm" variant="outline" data-testid={`decline-request-${p.profile_code}`} onClick={() => act(() => api.post(`/partners/${p.rel_id}/decline`), "Request declined")}><X className="mr-1 h-4 w-4" /> Decline</Button>
                </>}
              </Row>
            ))}
          </div>
        </div>
      )}
      {outgoing.length > 0 && (
        <div className="rounded-2xl border border-[#E5E0D8] bg-white p-5" data-testid="outgoing-requests">
          <p className="text-xs font-semibold uppercase tracking-wider text-stone-400">Waiting for their reply ({outgoing.length})</p>
          <div className="divide-y divide-[#F0ECE1]">
            {outgoing.map((p) => (
              <Row key={p.rel_id} p={p}>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-amber-600"><Clock className="h-3 w-3" /> Pending</span>
                {canCancel && <Button size="sm" variant="ghost" data-testid={`cancel-request-${p.profile_code}`} onClick={() => act(() => api.delete(`/partners/${p.rel_id}`), "Request cancelled")}>Cancel</Button>}
              </Row>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
